'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openKuaiBaoNewsUrl = exports.openKuaiBaoGuideUrl = exports.guideReport = exports.distributeTest = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.parseKuaibaoUrl = parseKuaibaoUrl;

var _url2 = require('url');

var _url3 = _interopRequireDefault(_url2);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _UA = require('./UA');

var _appInstall = require('./appInstall');

var _appInstall2 = _interopRequireDefault(_appInstall);

var _Layer = require('./urlHelper/Layer');

var _Layer2 = _interopRequireDefault(_Layer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/*
 * @Author: jerryfwang
 * @Date: 2019-05-17 15:01:56
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2019-08-27 11:57:35
 */
// 快报微视导流


var getAppUrl = function getAppUrl(id, ext) {
  // eslint-disable-next-line max-len
  var redirectUrl = 'qnreading://tab_reading?tab=kuaibao&chlid=daily_timeline&kd_insert=article&kd_content_id=' + id;
  if (ext) {
    redirectUrl += '&' + _queryString2.default.stringify(ext);
  }
  return redirectUrl;
};
/**
 * 解构快报url 返回id等信息的对象
 * @param  {String} url  快报地址
 * @return {Object}
 */
function parseKuaibaoUrl(url) {
  if (!url) {
    return {};
  }
  try {
    var urlObj = _url3.default.parse(url, true);

    var pathname = urlObj.pathname,
        _urlObj$query = urlObj.query,
        query = _urlObj$query === undefined ? {} : _urlObj$query,
        rest = _objectWithoutProperties(urlObj, ['pathname', 'query']);

    var exec = new _Layer2.default('/s/:id');
    var id = exec.params(pathname).id;
    return _extends({
      id: id,
      pathname: pathname,
      query: query
    }, rest);
  } catch (error) {
    return {};
  }
}
/**
 * 正则URL判断
 * @param  {String} url  url地址
 * @return {Number} type  快报是1 微视为0 其他为2
 */
var distributeTest = exports.distributeTest = function distributeTest(url) {
  var type = 2;
  if (url) {
    if (/^http(s)?:\/\/kuaibao\.qq\.com\//.test(url)) {
      type = 1;
    } else if (/^http(s)?:\/\/h5\.weishi\.qq\.com/.test(url) || /^http(s)?:\/\/act\.qzone\.qq\.com/.test(url)) {
      type = 0;
    }
  }
  return type;
};
/**
 * 快报等导量的上报
 * 回调方法传参 { contentType:11,logType:1曝光 2点击,logContent }
 * @param  {Function} reportFnc  上报方法
 * @param {Object} opts { logType 1曝光 2点击, from来源, sourceId资源位, local 自定义位置 install 是否安装 noDiff 无差别拉起标识}
 * @return {Void}
 */
var guideReport = exports.guideReport = function guideReport(reportFnc, _ref) {
  var logType = _ref.logType,
      from = _ref.from,
      sourceId = _ref.sourceId,
      _ref$local = _ref.local,
      local = _ref$local === undefined ? '' : _ref$local,
      install = _ref.install,
      _ref$noDiff = _ref.noDiff,
      noDiff = _ref$noDiff === undefined ? '' : _ref$noDiff;

  var userAgent = window.navigator.userAgent;
  var osType = '';
  if ((0, _UA.isIOS)(userAgent)) {
    osType = 'ios';
  } else if ((0, _UA.isAndroid)(userAgent)) {
    osType = 'android';
  }
  var isInstall = 0;
  if (install !== undefined) {
    isInstall = install ? 2 : 1;
  }
  // F9~F19 distribute 宿主id=0 osType sourceId imei actionType 1曝光 2点击 type=0 source 0-微视 1-快报 local:share_{},operation_{},correlate_{} install 0 不区分拉新拉活  1 拉新 2 拉活 noDiff 为1时是无差别拉起
  var log = ['distribute', '0', osType, sourceId, '', logType, '0', from, local, isInstall, noDiff];
  reportFnc && reportFnc({
    contentType: 11,
    logType: logType,
    logContent: log.join('|')
  });
};

/**
 * 打开快报导流页地址 如果安装了快报，则跳转到具体详情页地址 如果没有 跳转到下载页地址
 * 回调方法传参 { redirectUrl, install } 跳转地址及是否安装快报 安装快报打开方法只能是window.location.href
 * @param {String} url  url地址
 * @param {Object} extData {web,app}  h5和app地址中的扩展字段
 * @param {Function} clickFnc 回调方法
 * @return {Void}
 */
var openKuaiBaoGuideUrl = exports.openKuaiBaoGuideUrl = function openKuaiBaoGuideUrl(url) {
  var extData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var clickFnc = arguments[2];

  (0, _appInstall2.default)('kuaibao').then(function (ret) {
    var redirectUrl = '';

    var _parseKuaibaoUrl = parseKuaibaoUrl(url),
        id = _parseKuaibaoUrl.id;

    if (ret && id) {
      redirectUrl = getAppUrl(id, extData.app);
    } else {
      redirectUrl = 'https://kuaibao.qq.com/newsDownLoad?src=LIULANQI_ARTICLE';
      if (extData.web) {
        redirectUrl += '&' + _queryString2.default.stringify(extData.web);
      }
    }
    console.debug('===========openKuaiBaoGuideUrl', redirectUrl, ret);
    clickFnc && clickFnc({
      redirectUrl: redirectUrl,
      install: ret
    });
  }).catch(function (e) {
    console.log(e);
  });
};

/**
 * 打开快报详情页地址 如果安装了快报，则跳转到具体详情页地址 如果没有 跳转到对应的h5地址
 * 回调方法传参 { redirectUrl, install } 跳转地址及是否安装快报 安装快报打开方法只能是window.location.href
 * @param {String} url  url地址
 * @param {Object} extData {web,app} h5和app地址中的扩展字段
 * @param {Function} clickFnc 回调方法
 * @return {Void}
 */
var openKuaiBaoNewsUrl = function openKuaiBaoNewsUrl(url) {
  var extData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var clickFnc = arguments[2];

  (0, _appInstall2.default)('kuaibao').then(function (ret) {
    var redirectUrl = null;

    var _parseKuaibaoUrl2 = parseKuaibaoUrl(url),
        id = _parseKuaibaoUrl2.id,
        query = _parseKuaibaoUrl2.query,
        pathname = _parseKuaibaoUrl2.pathname,
        rest = _objectWithoutProperties(_parseKuaibaoUrl2, ['id', 'query', 'pathname']);

    if (ret && id) {
      redirectUrl = getAppUrl(id, extData.app);
    } else {
      var _query = Object.assign(query, {
        kd_content_id: id
      }, extData.web || {});
      var _url = _url3.default.format(_extends({
        query: _query,
        pathname: pathname
      }, rest));
      redirectUrl = _url;
    }
    console.debug('===========openKuaiBaoNewsUrl', redirectUrl, ret);
    clickFnc && clickFnc({
      redirectUrl: redirectUrl,
      install: ret
    });
  }).catch(function (e) {
    console.log(e);
  });
};
exports.openKuaiBaoNewsUrl = openKuaiBaoNewsUrl;